var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"rounded pa-5 mt-5 mb-5",attrs:{"color":_vm.color,"elevation":"1"}},[_c('p',{staticClass:"text-h5 font-weight-medium"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }